import { WeeklyRosterProvider } from 'contexts/weekly-roster.context';
import React from 'react';
import { Outlet } from 'react-router-dom';

const WeeklyRosterLayout = () => {
  return (
    <WeeklyRosterProvider>
      <Outlet />
    </WeeklyRosterProvider>
  );
};

export default WeeklyRosterLayout;
